<template>
  <div v-if="isVisible">
    <b-card bg-variant="statusWarning" class="w-100 card-container">
      <strong>{{ $t('xMobileLinkOutage') }}</strong>
      <div class="mt-2">{{ $t('xBillingMaintenanceMessage') }}</div>
    </b-card>
  </div>
</template>
<script>
import { BillingMigrationFeatureFlag } from '@/constants'
import { mapState } from 'vuex/dist/vuex.common.js'

export default {
  computed: {
    ...mapState({
      currentAppConfig: state => state.application.currentAppConfig
    }),
    isVisible() {
      return this.currentAppConfig?.featureFlags?.[BillingMigrationFeatureFlag]
    }
  },
  mounted() {
    if (!this.currentAppConfig) this.$store.dispatch('getApplicationConfiguration', 'Any')
  }
}
</script>
<style lang="scss">
.card-container {
  .card-body {
    padding: 1rem;
  }
}
</style>
